
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/building",
      function () {
        return require("private-next-pages/about/building.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/building"])
      });
    }
  